import React, { useEffect, useState } from "react";
import { BreadCrumb, CRUDTable, Tabs } from "../../../Components";
import { useStateContext } from "../../../contexts/ContextProvider";
import { IoEyeOutline, IoPencil, IoTrashOutline } from "react-icons/io5";


const UserListPro = () => {
  const [history, setHistory] = useState([]);
  const [techs, setTechs] = useState([]);
  const [pending, setPending] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const { userType } = useStateContext();
  const [selectedValue, setSelectedValue] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const prod = "https://lebontechnicien.net/";

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    // Fetch data from the "history" endpoint
    const id = sessionStorage.getItem("id");
  
    fetch(`${prod}request/history`, {
      method: "GET",
    })
      .then((res) => res.json())
      .then((data) => {
        // Filter the data
        const filteredData = data.filter((item) => item.created_by === id && (item.type === "Demande d'intervention" || item.type === "Demande de Maintenance") && item.adresse !== undefined);
  
        // Create a map to group data by "nom" and "prenom"
        const groupedData = filteredData.reduce((acc, item) => {
          const key = `${item.nom || item.nom_Pro}-${item.prenom || item.prenom_Pro}`;
          if (!acc[key]) {
            acc[key] = item;
          }
          return acc;
        }, {});
  
        // Convert the grouped map back to an array
        const uniqueData = Object.values(groupedData);
  
        // Set the state with the unique data
        setFilteredData(uniqueData.reverse());
      })
      .catch((error) => console.error(error));
  };

  useEffect(() => {
    const fetchData = async (type) => {
      const id = await sessionStorage.getItem("id");
      try {
        const response = await fetch(`${prod}find`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ type }),
        });
        const data = await response.json();
        const pendingData = data.filter((item) => item.creator === id)
        const pendingLength = data.filter((item) => item.creator === id).length;
        console.log('pendingLengthpendingLength', pendingLength)
        switch (type) {
          case "under_pro":
            setTechs(pendingData.reverse());
            setPending(pendingLength);
            break;
          default:
            break;
        }
      } catch (error) {
        console.error(error);
      }
    };
  
    fetchData("under_pro"); 
  }, []);  

  const monthNames = [
    "Janvier",
    "Février",
    "Mars",
    "Avril",
    "Mai",
    "Juin",
    "Juillet",
    "Août",
    "Septembre",
    "Octobre",
    "Novembre",
    "Décembre",
  ];

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate();
    const monthIndex = date.getMonth();
    const year = date.getFullYear();
    const monthName = monthNames[monthIndex];
    return `${day} ${monthName} ${year}`;
  };

const info = filteredData.map((item) => {
  const formatValue = (value, isClient = false) => {
    // Convert null/undefined to empty string first
    if (value === null || value === "null" || value === undefined) value = "";
    
    // For phone numbers specifically, we might want to handle numeric values
    if (typeof value === 'number') value = value.toString();
    
    // Now handle empty string case
    if (value === "") {
      return isClient ? " " : "-";
    }
    return value;
  };

  // Handle Client name
  const firstName = formatValue(item.nom || item.nom_Pro, true);
  const lastName = formatValue(item.prenom || item.prenom_Pro, true);
  const fullName = `${firstName} ${lastName}`.trim();

  return {
    id: item._id,
    Client: fullName || " ",
    Adresse: `${formatValue(item.adresse)} ${formatValue(item.ville)} ${formatValue(item.postale)}`.trim(),
    Appareil: `${formatValue(item?.typeDeProjet)} ${formatValue(item.marque)}`.trim(),
    Téléphone: formatValue(item.telephone),
  };
});

  return (
    <>
      <BreadCrumb
        From={""}
        To={"Liste Des Clients"}
        hrefFrom={"/tableau-de-bord"}
      />
      <div className="mt-10 max-w-screen-xl  ml-auto mr-auto">
        <CRUDTable
          data={info}
          link={`/client-appareils/`}
          eyeIcon={
            <IoEyeOutline
              style={{ fontSize: "18px", cursor: "pointer", color: "#f8c408" }}
            />
          }
        />
      </div>
    </>
  );
};

export default UserListPro;